__turbopack_context__.v({
  "chevron": "A-4N1q_chevron",
  "collapseToggle": "A-4N1q_collapseToggle",
});
